export const CHECKBOX_OTHERS_INPUT_KEY = 'othersInput'
export const CHECKBOX_OTHERS_INPUT_VALUE =
  '!!FORMSG_INTERNAL_CHECKBOX_OTHERS_VALUE!!'
